
import CopyFieldButton from '@/components/CopyFieldButton.vue'
import ActionOverflow from '@/components/ActionOverflow.vue'
import { isCopyField, isProductIdentifier } from '@/utils/copyFields'
import { useOrderCellTitles } from '@/utils/useOrderCellTitles'
import { useRoute } from 'vue-router'
import store from '@/store'
import { overflowKeys, safeOverflowText } from '@/utils/overflowDetail'
import { useOmittedOrderFields } from '@/utils/useOmittedOrderFields'
import { orderFitColumns, orderCellClass, orderTableScale } from '@/utils/orderTableFit'
// 2026-10-19：按用户要求撤销快递100隐私发货任务，恢复原订单发货及既有功能。
import { defineComponent,PropType,ref,watch ,Ref, computed, provide} from "vue";
import {DataColumns, DataItem,Columns,SubTableOption} from '@/Interfaces/user/DataItem';
import SubTable from './SubTable.vue'
// 2026-10-02：分页复用完整筛选结果，取消启用分页清单的原400行截断。
import { useListPagination } from '@/utils/useListPagination'
// 2026-09-17：仅显式启用的管理列表采用紧凑列宽，默认表格保持原显示。
import ListText from '../ListText.vue'
import CustomerMemoCell from '../CustomerMemoCell.vue'
import {memoCustomerId,withCustomerMemo} from '@/utils/customerMemoColumns'
import { compactColumnWidth } from '@/utils/compactList'
import { resolveTableLayout, declaredTableColumns, readableTableColumns } from '@/utils/responsiveTable'
import { memoEntry } from '@/utils/customerMemoState'
import dayjs from 'dayjs'
import { useTableContainer } from '@/utils/useTableContainer'
import { useActionColumns, fitActionColumns } from '@/utils/useActionColumns'
interface TableDataItem extends DataItem {
  extendColumn?: { [key: string]: string[]};
  name:string,
  selectedIndex?:number,
  subrowStatus?:{selectedIndex:number,overIndex:number}    
}
const __default__ = defineComponent({
  name:"FugleTable",
  inheritAttrs:false,
  components:{
    SubTable, ListText, CustomerMemoCell, CopyFieldButton, ActionOverflow
  },
  props:{
    secondaryFields:{type:Array as PropType<string[]>,default:()=>[]},
    mainOnlyFields:{type:Array as PropType<string[]>,default:()=>['orderNumber','productOwnership','storeInfo']},
    customerMemo:{type:Boolean,default:false},
    customerMemoAfter:{type:String,default:''},
    paginate:{type:Boolean,default:false},
    // 2026-09-17：只有四类商家/版师清单显式启用自适应；默认保留正式139声明布局。
    responsive:{type:Boolean,default:false},
    fitColumns:{type:Boolean,default:false},
    orderFit:{type:Boolean,default:false},
    fixedActions:{type:Boolean,default:true},
    compact:{ type:Boolean, default:false },
    tableTitle:{
      type:String,
    },
    data: {
      type: Object as PropType<any[]>,
      required: true
    },
    height:{
      type:String,

    },
    showSubItems:{
      type:Boolean,
      default:false
    },
    columns: {
      type: Object as PropType<DataColumns[]>,
      required: true
    },
    subColumns: {
      type: Object as PropType<DataColumns[]>,
    },
    styles:{
      type:Object,
      default:()=>{return {}}      
    },
    searchColumn:{
      type:Object as PropType<string[]>,
        required: true
    },
    windowWidth:{
      type:Number,
      default:1300
    },
    contentWidth:{
      type:Number,
      default:1800
    },
    searchText:{
      type:Object as PropType<Ref<string>>,
        required: true
    },
    headerStyle:{
      type:Object,
      default:()=>{return {'background-color':'#eef5f9'}}     
    },
    cellCenter:{
      type:Boolean,
      default:false
    },
    enableRowHover:{
      type:Boolean,
      default:true
    },
    pageSize:{
      type:Number,
      default:400
    },
    subTable:{
      type:Object as PropType<SubTableOption>
    },
    showSelected:{
      type:Boolean,
      default:true
    }
  },
  setup(props, { emit }) {
    const route=useRoute()
    const overflowEnabled=computed(()=>props.orderFit && /^\/(products|orders|customers)(\/|$)/.test(route.path))
    
    const dSource=ref<any[]>(props.data);
      dSource.value.forEach((itm:any)=>{
        if(!itm.extendColumn)
          itm.extendColumn={}
        if(props.searchColumn){
          for(let col of props.searchColumn){  
            if(props.searchText){
              itm.extendColumn[col]= [itm[col]]
            }
          }
        }
      })
      const subRowClick =(row)=>{
        console.log(row)
        emit('subRowClick',row)
      }
      const expandClick=(row)=>{
        if(row.expand && row.expand==true){
          row.expand=false
        }else{
          row.expand=true
        }
      }
      const filteredRows = computed(() => {
        const searchText = props.searchText?.value;  
        const searchColumns = props.searchColumn;  
        
        if (!searchText || searchColumns.length === 0) {
          if(dSource.value){  
            return dSource.value
          }else{
            return []
          }
        }  
        
        let rrs= dSource.value.filter(itm => {  
          return searchColumns.some(column => {  
            const itemValue = itm[column];  
            return itemValue && itemValue.indexOf(searchText) >= 0;  
          });  
        });  
        return rrs
      });
    const listPaging=useListPagination(()=>filteredRows.value)
    const dataSource=computed(()=>props.paginate ? listPaging.rows.value : filteredRows.value.slice(0,props.pageSize))
    watch(()=>props.data,()=>{
      dSource.value=props.data;
    })
    watch(() => props.searchText, () => {
      if(props.searchText){        
      dataSource.value.forEach((itm:TableDataItem)=>{
          if(!itm.extendColumn)
            itm.extendColumn={}
          if(props.searchColumn){
            for(let col of props.searchColumn){  
              if(props.searchText && itm[col]){
                // 2026-09-17：备注可包含括号等符号，紧凑列表按字面文本高亮，避免正则语法错误。
                const term=props.compact?props.searchText.value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'):props.searchText.value
                itm.extendColumn[col]= itm[col].toString().split(new RegExp(`(?<=${term})|(?=${term})`, 'i'))
                //console.log(itm.extendColumn)
              }
            }
          }
        }) 
      }
    })
    const tdCenter=computed(()=>props.cellCenter)
    const enableHover=computed(()=>props.enableRowHover)
    // 2026-09-17：深层响应列宽、容器和展开列变化，同字段父子行始终使用同一分配宽度。
    const compactEnabled=computed(()=>props.responsive && props.compact)
    provide('landiyun-responsive-table',computed(()=>props.responsive))
    provide('landiyun-order-fit',computed(()=>props.orderFit))
    const {container,width:containerWidth,availableHeight}=useTableContainer(()=>props.responsive)
    const forceFullColumns=ref(false)
    const detailRows=ref(new Set<any>())
    const compactDetails=computed(()=>{
      if(!props.responsive || !props.secondaryFields.length || !containerWidth.value || forceFullColumns.value)return false
      // 全部列的真实底线放得下就恢复显示，不按固定分辨率提前收起。
      const all=fitActionColumns(orderFitColumns(withCustomerMemo(props.columns,props.customerMemo,props.customerMemoAfter),filteredRows.value,keyWidths.value),actionWidths.value)
      const required=all.reduce((sum,column)=>sum+Number(column.fitFloor || column.minWidth || column.width || 80),25)
      return required>containerWidth.value
    })
    const detailColumns=computed(()=>withCustomerMemo(props.columns,props.customerMemo,props.customerMemoAfter).filter(column=>column.dataIndex && !isActionColumn(column) && !/(image|picture|thumbnail|img)/i.test(String(column.dataIndex))))
    const {omitted:omittedFields,rendered:renderedFields}=useOmittedOrderFields(container,()=>overflowEnabled.value)
    const detailsForRow=(index:number)=>{const keys=overflowKeys(compactDetails.value?props.secondaryFields:[],omittedFields.value[String(index)] || [],props.mainOnlyFields);return detailColumns.value.filter(column=>keys.has(String(column.dataIndex)))}
    const subDetailsForRow=(index:number,subIndex:number)=>{
      const keys=overflowKeys(compactDetails.value?props.secondaryFields:[],omittedFields.value['sub:'+index+':'+subIndex] || [],props.mainOnlyFields)
      return withCustomerMemo(props.subColumns || [],props.customerMemo && !!props.subColumns?.length,props.customerMemoAfter).filter(column=>column.dataIndex && !isActionColumn(column) && !/(image|picture|thumbnail|img)/i.test(String(column.dataIndex)) && keys.has(String(column.dataIndex)))
    }
    const primaryColumns=computed(()=>compactDetails.value?props.columns.filter(column=>!props.secondaryFields.includes(String(column.dataIndex))):props.columns)
    const toggleDetail=(row:any)=>{const next=new Set(detailRows.value);next.has(row)?next.delete(row):next.add(row);detailRows.value=next}
    const detailMemo=(row:any)=>{const id=memoCustomerId(row);if(!id)return '—';const state=memoEntry(id);return state.error || state.memo || '—'}
    const detailValue=(value:any,column:any,index:number|string)=>{
      const rendered=renderedFields.value[String(index)]?.[String(column.dataIndex)]
      if(rendered!==undefined)return safeOverflowText(rendered,String(column.dataIndex),Boolean(store.getters.sysFunctions?.viewCustomerPhoneNumber))
      if(value==null || value==='')return '—'
      if(/(time|date|createdAt|updatedAt)$/i.test(String(column.dataIndex)) && dayjs(value).isValid())return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
      return typeof value==='object'?JSON.stringify(value):safeOverflowText(value,String(column.dataIndex),Boolean(store.getters.sysFunctions?.viewCustomerPhoneNumber))
    }
    const keyWidths=useOrderCellTitles(container,()=>props.orderFit)
    const {widths:actionWidths,isActionColumn:nativeIsActionColumn,actionColumnKey}=useActionColumns(container,()=>props.fixedActions)
    const isActionColumn=(column:any)=>column.dataIndex==='__omittedDetails' || nativeIsActionColumn(column)
    const displayColumns=computed(()=>props.orderFit?orderFitColumns(withCustomerMemo(primaryColumns.value,props.customerMemo,props.customerMemoAfter),filteredRows.value,keyWidths.value):withCustomerMemo(primaryColumns.value,props.customerMemo))
    const displaySubColumns=computed(()=>props.orderFit?orderFitColumns(withCustomerMemo(props.subColumns || [],props.customerMemo && !!props.subColumns?.length,props.customerMemoAfter),filteredRows.value.flatMap(row=>row.subRows || []),keyWidths.value):withCustomerMemo(props.subColumns || [],props.customerMemo && !!props.subColumns?.length))
    const actionColumns=computed(()=>{
      const columns=props.fixedActions?fitActionColumns(displayColumns.value,actionWidths.value):displayColumns.value
      if(!overflowEnabled.value || columns.some(isActionColumn) || !Object.keys(omittedFields.value).some(index=>detailsForRow(Number(index)).length))return columns
      return [...columns,{title:'',key:'__omittedDetails',dataIndex:'__omittedDetails',fixed:'right',width:34,minWidth:34,maxWidth:34,fitFloor:34,flex:0,orderFit:true,slots:{customRender:'overflow-details'}}]
    })
    const actionSubColumns=computed(()=>props.fixedActions?fitActionColumns(displaySubColumns.value,actionWidths.value):displaySubColumns.value)
    const layout=computed(()=>resolveTableLayout(props.fitColumns?readableTableColumns(actionColumns.value):actionColumns.value,props.showSubItems && props.subTable ? props.fitColumns?readableTableColumns(actionSubColumns.value):actionSubColumns.value : [],containerWidth.value,props.compact,props.showSubItems?26:0))
    const cols=computed(()=>props.responsive?layout.value.columns:declaredTableColumns(actionColumns.value)),subcols=computed(()=>props.responsive?layout.value.subColumns:declaredTableColumns(actionSubColumns.value))
    const tableWidth=computed(()=>(props.responsive?layout.value.width:props.contentWidth)+'px')
    const fitScale=computed(()=>props.orderFit?orderTableScale(layout.value.width,containerWidth.value):1)
    const winWidth=ref(props.windowWidth+'px')
    const mainTable=ref();
    let showLeftShadow=ref(false);
    let showRightShadow=ref(true);
    const rowStatus=ref({
      overIndex:-1,
      selectedIndex:-1
    });
    const subRowStatus=ref({
      overIndex:-1,
      selectedIndex:-1
    });
    // 2026-10-02：翻页后重置行位置状态，避免高亮错落到下一页另一条记录。
    watch([listPaging.current,listPaging.pageSize],()=>{
      rowStatus.value={overIndex:-1,selectedIndex:-1}
      subRowStatus.value={overIndex:-1,selectedIndex:-1}
      if(container.value)container.value.scrollTop=0
    })
    const handleMouseOver=(index:number)=>{
      if(enableHover.value){
      //console.log(enableHover.value)
      rowStatus.value.overIndex=index;
      }
    }
    const mouselevel =() =>{
      rowStatus.value.overIndex=-1
    }
    const selectItem=(item:TableDataItem,index:number)=>{
      rowStatus.value.selectedIndex=index
      emit("rowcick",item)
    }

    const subhandleMouseOver=(row:TableDataItem, index:number|string)=>{
      if(enableHover.value){
      //console.log(enableHover.value)
      subRowStatus.value.overIndex=index as any;
      if(!row.subrowStatus){
        row.subrowStatus={selectedIndex:-1,overIndex:index as any}
      }
      row.subrowStatus.overIndex=index as any
      }
    }
    const submouselevel =(item:TableDataItem) =>{
      subRowStatus.value.overIndex=-1
      if(!item.subrowStatus){
        item.subrowStatus={selectedIndex:-1,overIndex:-1}
      }
      item.subrowStatus.overIndex=-1
    }
    const subselectItem=(row,item:TableDataItem,index:number|string)=>{
      if(!row.subrowStatus){
        row.subrowStatus={selectedIndex:index,overIndex:-1}
      }
      row.subrowStatus.selectedIndex=index
      emit("rowcick",item)
    }
    const getClassNames=(col)=>{ 
      //console.log(col)    
      let classNames:string[]=[];
      if(props.orderFit)classNames.push(orderCellClass(col));
      if(isCopyField(col) && !(col.dataIndex==='orderNumber' && !col.slots))classNames.push('copy-field-cell');
      if(isProductIdentifier(col))classNames.push('identifier-field-cell');
      if(props.orderFit && String(col.className || '').split(/\s+/).includes('order-fit-short'))classNames.push('order-fit-short');
      if(showLeftShadow.value && col.fixed=='left') classNames.push('shadow-left');
      if(showRightShadow.value && col.fixed=='right') classNames.push('shadow-right');
      if(col.fixed && col.fixed=='right') classNames.push('col-fixed-right');
      if(col.fixed && col.fixed=='left') classNames.push('col-fixed');
      return classNames;
    }
    const scrollEvent=(e)=>{         
        showRightShadow.value=!(e.target.scrollLeft + e.target.clientWidth >= e.target.scrollWidth-2)
        showLeftShadow.value=e.target.scrollLeft>0
    }
    const cacColumnStyle=(col,isHeader,isdiv,index)=>{
      let style = {}
      if(col.width)style['width']=props.responsive && isdiv?'100%':col.width+'px'
      if(props.responsive)style['box-sizing']='border-box'
      if(index==0 && props.showSubItems){
        style['padding-left']='0'
      }
      if(col.fixed=='left' && !isdiv){
        style['left'] = col.fixedWidth+'px'
        if(isHeader){
          style['z-index']=4;
        //style['box-shadow']='0px 0px 5px #ccc'
        }
      }
      if(col.fixed==='right' && !isdiv)style['right']=(col.rightOffset || 0)+'px'
      if(props.fixedActions && isActionColumn(col) && !isdiv){style['min-width']=col.width+'px';style['max-width']=col.width+'px'}
      if(compactEnabled.value && col.fixed==='right' && isHeader) style['z-index']=5
      if(isHeader){
        if(props.headerStyle){   
          Object.keys(props.headerStyle).forEach((key)=>{
            style[key]=props.headerStyle[key]
          })          
        }
      }
      
      return style
    }
    const subcacColumnStyle=(col,isHeader,isdiv,index)=>{
      const style=cacColumnStyle(col,isHeader,isdiv,index)
      if(!props.responsive && index===0)style['padding-left']='10px'
      return style
    }
    const baseStyle=computed(()=>props.responsive?({
      ...props.styles,width:'100%',minWidth:'0',maxWidth:'100%',
      height:availableHeight.value!==null && props.height?.includes('vh') ? availableHeight.value+'px' : props.height || 'unset',
      ...(availableHeight.value!==null?{maxHeight:availableHeight.value+'px'}:{})
    }):({...(props.fixedActions && props.columns.some(isActionColumn)?{width:'100%',minWidth:'0',maxWidth:'100%'}:{}),...props.styles,height:props.height || 'unset'}))
    return {
      isCopyField,isProductIdentifier,overflowEnabled,forceFullColumns,compactDetails,detailColumns,detailsForRow,subDetailsForRow,detailRows,toggleDetail,detailValue,detailMemo,
      memoCustomerId,listPaging,emit,props,cacColumnStyle,compactColumnWidth,compactEnabled,ref,subRowStatus,baseStyle,subRowClick,scrollEvent,mouselevel,tdCenter,cols,
      subhandleMouseOver,submouselevel,subselectItem,subcacColumnStyle,expandClick,subcols,
      isActionColumn,actionColumnKey,rowStatus,container,mainTable,selectItem,handleMouseOver,showLeftShadow,tableWidth,fitScale,winWidth,showRightShadow,getClassNames,dataSource
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "1729fea9": (_ctx.tableWidth)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__